import {
  Button,
  Card,
  danger,
  ErrorAlert,
  Input,
  success,
  SwitchInput,
  useCanShow,
  useCustomForm,
  useEffect,
  useFetchData,
} from "@";
import { contactSchema } from "./utils/validation";
import { getContacts, saveContacts } from "./utils/api";

const Contacts = () => {
  const {
    reset,
    watch,
    setValue,
    register,
    handleSubmit,
    isSubmitting,
    errors,
  } = useCustomForm({}, contactSchema);

  const { error, fetchData } = useFetchData({
    fill: reset,
    fun: getContacts,
  });

  // Handle form submission
  const submit = async (data) => {
    try {
      await saveContacts(data);
      success("تم الحفظ بنجاح");
    } catch (error) {}
  };

  // Show error alert if there are form errors
  useEffect(() => {
    if (Object.keys(errors).length > 0) danger("يوجد خطأ في البيانات المدخلة");
  }, [errors]);
  return (
    <>
      {/* error alert */}
      <ErrorAlert reload={fetchData} show={error} />

      <form
        onSubmit={handleSubmit(submit)}
        className="relative grid gap-5 xl:grid-cols-2"
      >
        {/*  person */}
        <Card title="مدير الموقع" className="xl:col-span-3">
          <div className="grid gap-5 md:grid-cols-2">
            {/* websiteManagerName */}
            <Input input={register("websiteManagerName")} star label="الاسم" />

            {/* websiteManagerPhone */}
            <Input
              input={register("websiteManagerPhone")}
              star
              dir="ltr"
              styles="text-start input"
              label="الجوال"
              error={errors.websiteManagerPhone}
            />

            {/* websiteManagerEmail */}
            <Input
              input={register("websiteManagerEmail")}
              star
              type="email"
              error={errors.websiteManagerEmail}
              label="البريد الالكتروني"
            />

            {/* websiteManagerNotificationNumber */}
            <Input
              input={register("websiteManagerNotificationNumber")}
              star
              error={errors.websiteManagerNotificationNumber}
              label="جوال الاشعارات"
            />

            {/* enableBankTransferNotification */}

            <SwitchInput
              label="تفعيل اشعار التحويل البنكي"
              checked={watch("enableBankTransferNotification")}
              change={(value) =>
                setValue("enableBankTransferNotification", value)
              }
            />
            <SwitchInput
              label="تفعيل اشعار عمليات الفيزا"
              checked={watch("enableBankTransferNotification")}
              change={(value) =>
                setValue("enableBankTransferNotification", value)
              }
            />
          </div>
        </Card>

        {/* ceo */}
        <Card title="المدير التنفيذي">
          <div className="grid grid-cols-1 gap-5">
            {/* ceoName */}
            <Input input={register("ceoName")} star label="الاسم" />

            {/* ceoPhone */}
            <Input
              error={errors.ceoPhone}
              input={register("ceoPhone")}
              star
              dir="ltr"
              styles="text-start input"
              label="الجوال"
            />

            {/* ceoEmail */}
            <Input
              input={register("ceoEmail")}
              star
              type="email"
              error={errors.ceoEmail}
              label="البريد الالكتروني"
            />
          </div>
        </Card>

        {/* techManager */}
        <Card title="المسؤول التقني">
          <div className="grid grid-cols-1 gap-5">
            {/* techManagerName */}
            <Input input={register("techManagerName")} star label="الاسم" />

            {/* techManagerPhone */}
            <Input
              input={register("techManagerPhone")}
              star
              dir="ltr"
              styles="text-start input"
              error={errors.techManagerPhone}
              label="الجوال"
            />

            {/* techManagerEmail */}
            <Input
              input={register("techManagerEmail")}
              star
              error={errors.techManagerEmail}
              type="email"
              label="البريد الالكتروني"
            />
          </div>
        </Card>

        {useCanShow("editAssociationData") && (
          <div className="floating-btn md:col-span-2 xl:col-span-3">
            <Button
              isLoading={isSubmitting}
              type="submit"
              title="حفظ البيانات"
            />
          </div>
        )}
      </form>
    </>
  );
};

export default Contacts;
